import gql from 'graphql-tag';
import compose from 'lodash/flowRight';
import React from 'react';
import { graphql, withApollo } from 'react-apollo';
import { connect, useSelector } from 'react-redux';

import {
  getActiveConversation,
  getActiveConversationTopicsOfFocus,
} from 'src/selectors/chatSelectors';

import ChatInputForm from '../components/Chat/ChatInputForm/ChatInputForm';
import ChatMessageList from '../components/Chat/ChatMessageList';
import ChatPanelHeader from '../components/Chat/ChatPanelHeader';

enum ChatMessagesPanelTestID {
  MemberName = 'ChatMessagesPanelTestID.MemberName',
}

const Chat = (props) => {
  const activeConversation = useSelector(getActiveConversation);
  const memberTopicsOfFocus = useSelector(getActiveConversationTopicsOfFocus);

  const sendReadReceipt = () => {
    if (activeConversation) {
      props.createReadReceiptMutation({
        variables: {
          conversationUuid: activeConversation.uuid,
        },
      });
    }
  };

  const { currentUser, showMembersList, showMemberProfileDrawer } = props;

  if (!activeConversation) {
    return null;
  }

  const currentChatPartner =
    currentUser.uuid === activeConversation.member.uuid
      ? activeConversation.coach
      : activeConversation.member;

  return (
    <React.Fragment>
      <ChatPanelHeader
        title={`${currentChatPartner.firstName} ${currentChatPartner.lastName}`}
        onClickBack={showMembersList}
        onClickChatMemberSettings={showMemberProfileDrawer}
        testID={ChatMessagesPanelTestID.MemberName}
        showTopics
        topicsOfFocus={memberTopicsOfFocus ?? []}
      />

      <ChatMessageList onReadConversation={sendReadReceipt} />

      <ChatInputForm />
    </React.Fragment>
  );
};

const createReadReceipt = gql`
  mutation ReadConversation($conversationUuid: UUID!) {
    readConversation(conversationUuid: $conversationUuid) {
      ok
    }
  }
`;

const mapState = (state) => ({
  currentUser: state.user.currentUser,
});

const mapDispatch = (store) => ({});

export default compose(
  connect(mapState, mapDispatch),
  withApollo,
  graphql(createReadReceipt, { name: 'createReadReceiptMutation' }),
)(Chat);
